const validRate = (value) => Number.isFinite(Number(value)) && Number(value) > 0;
const fallbackRate = (currency, rates) => currency === 'TRY' ? 1 : validRate(rates[currency]) ? Number(rates[currency]) : 1;

export const getLedgerExchangeRate = (row, sourceCurrency, targetCurrency, rates = {}) => {
  if (sourceCurrency === targetCurrency) return 1;
  const savedRate = [row.exchangeRate, row.invoice?.exchangeRate, row.raw?.exchangeRate]
    .find((value) => validRate(value) && Number(value) > 1);
  const sourceRate = sourceCurrency === 'TRY' ? 1 : savedRate !== undefined ? Number(savedRate) : fallbackRate(sourceCurrency, rates);
  const targetRate = targetCurrency === 'TRY' ? 1 : fallbackRate(targetCurrency, rates);
  return sourceRate / targetRate;
};

export const convertLedgerAmount = (amount, rate) => Math.round((Number(amount || 0) * rate + Number.EPSILON) * 100) / 100;
